export default "__VITE_ASSET__CbVNes8d__"